var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { cursor: "help" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.$emit("onOpen", _vm.model)
        },
      },
    },
    [
      _c(
        "v-badge",
        {
          staticClass: "ma-0",
          attrs: {
            bordered: "",
            top: "",
            color: "red",
            overlap: "",
            dot: _vm.model.has_message ? true : false,
            value: _vm.model.has_message,
          },
        },
        [
          _c(
            "v-icon",
            { attrs: { color: "grey", small: _vm.small, dense: _vm.dense } },
            [_vm._v(" mdi-chat-processing-outline ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }